/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentCategory = {
    properties: {
        category: {
    type: 'string',
    isRequired: true,
},
        id: {
    type: 'number',
    isRequired: true,
},
    },
};